var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickSicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4437 25.2015C19.956 24.562 21.3142 23.6463 22.4803 22.4803L22.4803 22.4803C23.6462 21.3142 24.5619 19.956 25.2015 18.4438C25.828 16.9626 26.1625 15.3943 26.197 13.779L26.2014 13.5748H25.9971H24.542H24.3468L24.3421 13.7699C24.1984 19.6257 19.3898 24.3454 13.5 24.3454C7.52011 24.3454 2.65468 19.48 2.65468 13.5C2.65468 7.52011 7.52005 2.65468 13.5 2.65468C14.8283 2.65468 16.119 2.88758 17.3369 3.34651C18.5495 3.80348 19.6633 4.47438 20.6476 5.34118L20.6532 5.34665L20.66 5.35336C20.6811 5.37668 20.682 5.42357 20.6608 5.44758L20.6589 5.44969L20.1549 6.03584L19.8708 6.36623H20.3066H22.9031H23.1295L23.1016 6.14157L22.7738 3.50329L22.7181 3.05515L22.4237 3.39755L21.9653 3.93059L21.9653 3.93057L21.963 3.93328C21.9544 3.9437 21.9376 3.95386 21.9138 3.95553C21.8901 3.9572 21.872 3.94949 21.862 3.94039L21.862 3.94037L21.8594 3.93806C20.8949 3.09257 19.8076 2.39952 18.628 1.87814L18.6279 1.87813C17.0089 1.16271 15.2832 0.8 13.5 0.8C11.7867 0.8 10.1231 1.13597 8.55619 1.7986L8.55619 1.7986C7.04398 2.43816 5.68576 3.35381 4.51969 4.51974L4.51967 4.51976C3.35373 5.68583 2.43809 7.04411 1.79853 8.55625L1.79853 8.55626C1.1359 10.1231 0.8 11.7867 0.8 13.5C0.8 15.2133 1.13597 16.8769 1.7986 18.4438L1.9828 18.3659L1.7986 18.4438C2.43816 19.956 3.3538 21.3142 4.51974 22.4803L4.51976 22.4803C5.68583 23.6463 7.04409 24.562 8.55624 25.2015C10.1227 25.8641 11.7863 26.2 13.5 26.2C15.2137 26.2 16.8773 25.864 18.4437 25.2015ZM18.4437 25.2015L18.3683 25.0232L18.4437 25.2015C18.4437 25.2015 18.4437 25.2015 18.4437 25.2015Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11719 10.709V16.6072L13.2252 19.5562V13.658L8.11719 10.709Z",
    fill: "#1361F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5025 7.28516L8.39453 10.2342L13.5025 13.1833L18.6105 10.2342L13.5025 7.28516Z",
    fill: "#1361F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8814 10.709L13.7734 13.658V19.5562L18.8814 16.6072V10.709Z",
    fill: "#1361F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSicon3);
export default __webpack_public_path__ + "static/media/quick_sicon3.d2df4feff6a1346c9a6e313f4b7df79f.svg";
export { ForwardRef as ReactComponent };